import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Button } from '@mui/material';
import GetDataApi from 'src/common/FetchData/GetDataApi';
import Toaster from 'src/Toaster/Toaster';
const Toast = Toaster();
export type ISpecificGroup = {
  name: string;
  id: number;
  members: { user_member_id: number; user_member_company_name: string }[];
};
const SpecificRemoveFromGroup = ({
  id,
  setRemoveMember,
  existMember,
}: {
  id: any;
  setRemoveMember: React.Dispatch<React.SetStateAction<number[]>>;
  existMember: number[];
}) => {
  const { response, getData, loading } = GetDataApi<ISpecificGroup>(
    `/api/admin/member-group/${id}`
  );
  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);

  const [checkedItems, setCheckedItems] = useState<{ [key: number]: boolean }>(
    {}
  );

  const handleChange = (event, user_member_id) => {
    setCheckedItems({
      ...checkedItems,
      [user_member_id]: event.target.checked,
    });
  };

  const handleSubmit = () => {
    const selectedIds = Object.keys(checkedItems)
      .filter((user_member_id) => checkedItems[user_member_id])
      .map(Number);
    if (selectedIds.length > 0) {
      setRemoveMember(selectedIds);
    } else {
      Toast.fire({
        icon: 'error',
        title: 'No member selected to remove?',
      });
    }
  };

  const existMeber = [11, 22];
  return (
    <div>
      <div
        className='grid-container'
        style={{
          display: 'grid',
          gap: '10px',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          backgroundColor: 'rgb(233 235 241)',
          padding: '5px',
          borderRadius: '5px',
        }}
      >
        {response?.members?.map((member, index) => (
          <FormControlLabel
            key={index} // Ensure you have a unique key for each item
            control={
              <Checkbox
                size='small'
                checked={checkedItems[member?.user_member_id] || false} // Dynamically handle checked state based on user_member_id
                onChange={(event) =>
                  handleChange(event, member?.user_member_id)
                } // Pass user_member_id to your change handler
                name={`item${index + 1}`} // Dynamic name (optional, for debugging)
              />
            }
            label={
              <>
                <span
                  style={{
                    borderBottom: existMember?.includes(member.user_member_id)
                      ? '1px solid red'
                      : '',
                  }}
                >
                  {member.user_member_company_name}
                </span>
              </>
            } // Dynamic label based on index or member data
          />
        ))}
      </div>
      <Button
        sx={{ mt: 2 }}
        size='small'
        variant='outlined'
        color='error'
        onClick={handleSubmit}
      >
        Remove Done
      </Button>
    </div>
  );
};

export default SpecificRemoveFromGroup;
